<template>
  <v-container fluid>
    <v-data-table :headers="geaderTable1" :items="items_consig" :search="search_consignatarios">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('consignees-table-top-t1') }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search_consignatarios"
            :label="$t('search')"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevoConsignatario()"> {{ $t('consignees-table-top-btn1') }} </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action_editar`]="{ item }">
        <v-icon @click="editarConsignatario(item)"
          >fa-solid fa-pen-to-square</v-icon
        >
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="800" scrollable persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="2">
              <v-text-field
                v-model="tipo"
                :label="$t('consignees-dialog-input-label-t1')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="codigo"
                :label="$t('consignees-dialog-input-label-t2')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="nombre"
                :label="$t('consignees-dialog-input-label-t3')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="direccion"
                :label="$t('consignees-dialog-input-label-t4')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="ciudad"
                :label="$t('consignees-dialog-input-label-t5')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="estado"
                :label="$t('consignees-dialog-input-label-t6')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="pais"
                :label="$t('consignees-dialog-input-label-t7')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="zip"
                :label="$t('consignees-dialog-input-label-t8')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="registro_fiscal"
                :label="$t('consignees-dialog-input-label-t9')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" v-if="flag == 1" @click="crearConsignatario()"
            >{{ $t('btn-save') }}</v-btn
          >
          <v-btn
            color="primary"
            v-if="flag == 2"
            @click="actualizarConsignatario()"
            >{{ $t('btn-update') }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="limpiar()">{{ $t('btn-close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="-1"
      color="blue"
      multi-line
      elevation="24"
      outlined
      top
      right
    >
      <v-icon>{{ snackbar_icon }}</v-icon>
      {{ snackbar_text }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar = false">
          <v-icon>fa-regular fa-circle-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    search_consignatarios: "",
    snackbar: false,
    snackbar_icon: "fa-solid fa-circle-info",
    snackbar_text: "...",
    items_consig: [],
    dialog: false,
    id_clintes_consignados: 0,
    id_empresa: 0,
    tipo: "",
    codigo: "",
    nombre: "",
    direccion: "",
    ciudad: "",
    estado: "",
    pais: "",
    zip: "",
    flag: 1,
    registro_fiscal: ""
  }),
  created() {
    this.listarConsignatarios();
  },
  computed: {
    geaderTable1() {
      return [
        { text: this.$t('consignees-table-header-t1'), value: "codigo_cliente" },
        { text: this.$t('consignees-table-header-t2'), value: "consignatarios" },
        { text: this.$t('consignees-table-header-t3'), value: "direccion" },
        { text: this.$t('consignees-table-header-t4'), value: "pais" },
        {
          text: this.$t('consignees-table-header-t5'),
          value: "action_editar",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  methods: {
    listarConsignatarios() {
      axios
        .get("api/Consignatarios/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items_consig = response.data;
        });
    },
    nuevoConsignatario() {
      this.flag = 1;
      this.dialog = true;
    },
    crearConsignatario() {
      axios
        .post("api/Consignatarios/Crear", {
          id_empresa: this.$store.state.emp.id_empresa,
          tipo: this.tipo,
          codigo_cliente: this.codigo,
          consignatarios: this.nombre,
          direccion: this.direccion,
          ciudad: this.ciudad,
          estado: this.estado,
          zip: this.zip,
          pais: this.pais,
          registro_fiscal: this.registro_fiscal
        })
        .then(() => {
          this.snackbar_text = this.$t('consignees-snackbar-t1');
          this.snackbar = true;
          this.dialog = false;
          this.limpiar();
          this.listarConsignatarios();
        })
        .catch(() => {
          this.snackbar_text = this.$t('consignees-snackbar-t2');
          this.snackbar = true;
        });
    },
    actualizarConsignatario() {
      axios
        .put("api/Consignatarios/Actualizar", {
          id_clintes_consignados: this.id_clintes_consignados,
          id_empresa: this.id_empresa,
          tipo: this.tipo,
          codigo_cliente: this.codigo,
          consignatarios: this.nombre,
          direccion: this.direccion,
          ciudad: this.ciudad,
          estado: this.estado,
          zip: this.zip,
          pais: this.pais,
          registro_fiscal: this.registro_fiscal
        })
        .then(() => {
          this.snackbar_text = this.$t('consignees-snackbar-t3');
          this.snackbar = true;
          this.dialog = false;
          this.limpiar();
          this.listarConsignatarios();
        })
        .catch(() => {
          this.snackbar_text = this.$t('consignees-snackbar-t4');
          this.snackbar = true;
        });
    },
    editarConsignatario(item) {
      //console.log(item);
      this.id_clintes_consignados = item.id_clintes_consignados;
      this.id_empresa = item.id_empresa;
      this.tipo = item.tipo;
      this.codigo = item.codigo_cliente;
      this.nombre = item.consignatarios;
      this.direccion = item.direccion;
      this.ciudad = item.ciudad;
      this.estado = item.estado;
      this.pais = item.pais;
      this.zip = item.zip;
      this.registro_fiscal = item.registro_fiscal;

      this.flag = 2;
      this.dialog = true;
    },
    limpiar() {
      this.dialog = false;
      this.flag = 1;

      this.id_clintes_consignados = 0;
      this.id_empresa = 0;
      this.tipo = "";
      this.codigo = "";
      this.nombre = "";
      this.direccion = "";
      this.ciudad = "";
      this.estado = "";
      this.pais = "";
      this.zip = "";
      this.registro_fiscal = "";
    },
  },
};
</script>